/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Nowlanreason2Inputs */

const de__field_nowlanreason2 = /** @type {(inputs: _Field_Nowlanreason2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grund für kein WLAN-Verfügbarkeit`)
};

/**

* @param {_Field_Nowlanreason2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_nowlanreason2 = /** @type {((inputs?: _Field_Nowlanreason2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Nowlanreason2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_nowlanreason2(inputs)
});
export { _field_nowlanreason2 as "_field_noWlanReason" }